export default __webpack_public_path__ + "static/Desktop@2x-da5862379c95fe2ef57d9f4caaea64e4.jpg";